var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"slide-fade"},on:{"before-enter":_vm.beforeEnter,"enter":_vm.onEnter,"before-leave":_vm.beforeLeave,"leave":_vm.onLeave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }